<div class="gl" *ngIf="state === 'ready' && pub as p; else notReady">
  <!-- Hero: the real cover and one clear action -->
  <header class="gl-hero">
    <div class="gl-wrap">
      <nav class="gl-crumb" aria-label="Breadcrumb">
        <a routerLink="/blog">Insights &amp; Opinion</a>
        <span aria-hidden="true">/</span>
        <a routerLink="/market-guides">Market Guides</a>
      </nav>

      <div class="gl-hero-grid">
        <div class="gl-hero-head">
          <p class="gl-eyebrow">PlateX Market Guides<span *ngIf="p.issueLabel"> · {{ p.issueLabel }}</span></p>
          <h1 class="gl-title">{{ p.title }}</h1>
          <p class="gl-sub">{{ p.subtitle }}</p>
        </div>

        <figure class="gl-cover">
          <button type="button" class="gl-cover-btn" (click)="scrollTo('inside')" aria-label="See sample pages">
            <img [src]="p.coverUrl" [alt]="'Cover of ' + p.title" width="620" height="877" />
          </button>
        </figure>

        <div class="gl-hero-body">
          <div #heroCta>
            <ng-container *ngTemplateOutlet="cta; context: { $implicit: p }"></ng-container>
          </div>
          <p class="gl-standfirst" *ngIf="p.landing?.standfirst">{{ p.landing.standfirst }}</p>
          <p class="gl-meta">
            <span *ngIf="p.edition">{{ p.edition }} edition</span>
            <span *ngIf="p.landing?.format">{{ p.landing.format }}</span>
            <a class="gl-meta-link" (click)="scrollTo('inside')" role="button" tabindex="0" (keydown.enter)="scrollTo('inside')">Preview pages</a>
          </p>
        </div>
      </div>
    </div>
  </header>

  <!-- What the research found -->
  <section class="gl-research" *ngIf="p.landing?.highlights?.length || p.landing?.example">
    <div class="gl-wrap">
      <p class="gl-eyebrow gl-eyebrow--dark">The research</p>
      <div class="gl-research-grid">
        <div class="gl-example" *ngIf="p.landing.example as ex">
          <span class="plate-font gl-plate">{{ ex.registration }}</span>
          <div class="gl-example-figs">
            <div>
              <span class="gl-fig">{{ ex.bought }}</span>
              <span class="gl-fig-note">{{ ex.boughtNote }}</span>
            </div>
            <span class="gl-arrow" aria-hidden="true">→</span>
            <div>
              <span class="gl-fig gl-fig--big">{{ ex.sold }}</span>
              <span class="gl-fig-note">{{ ex.soldNote }}</span>
            </div>
          </div>
        </div>
        <ul class="gl-highlights">
          <li *ngFor="let h of p.landing.highlights">
            <span class="gl-hl-value">{{ h.value }}</span>
            <span class="gl-hl-label">{{ h.label }}</span>
          </li>
        </ul>
      </div>
    </div>
  </section>

  <!-- About the guide -->
  <section class="gl-about">
    <div class="gl-wrap gl-narrow">
      <h2 class="gl-h2">About this guide</h2>
      <p class="gl-desc">{{ p.description }}</p>
      <p class="gl-byline" *ngIf="p.landing?.byline">{{ p.landing.byline }}</p>
    </div>
  </section>

  <!-- Sample pages -->
  <section class="gl-inside" id="inside" *ngIf="previews.length">
    <div class="gl-wrap">
      <div class="gl-inside-head">
        <h2 class="gl-h2">Inside the guide</h2>
        <p class="gl-hint">{{ previews.length }} sample pages. Tap a page to read it.</p>
      </div>
      <div class="gl-pages" role="list">
        <button
          type="button"
          class="gl-page"
          role="listitem"
          *ngFor="let pg of previews; let i = index"
          (click)="openPreview(i)"
          [attr.aria-label]="'Open sample page ' + pg.page"
        >
          <img [src]="pg.thumb" [alt]="'Sample page ' + pg.page" loading="lazy" width="480" height="679" />
          <span class="gl-page-no">Page {{ pg.page }}</span>
        </button>
      </div>
    </div>
  </section>

  <!-- Contents -->
  <section class="gl-contents" *ngIf="p.landing?.contents?.length">
    <div class="gl-wrap gl-narrow">
      <h2 class="gl-h2">What's inside</h2>
      <ol class="gl-toc">
        <li *ngFor="let c of p.landing.contents">
          <span class="gl-toc-title">{{ c.title }}</span>
          <span class="gl-toc-page">{{ c.page }}</span>
        </li>
      </ol>
    </div>
  </section>

  <!-- Closing action -->
  <section class="gl-close">
    <div class="gl-wrap gl-narrow">
      <img class="gl-close-cover" [src]="p.coverUrl" alt="" width="160" height="226" loading="lazy" />
      <h2 class="gl-close-title">{{ p.title }}</h2>
      <ng-container *ngTemplateOutlet="cta; context: { $implicit: p }"></ng-container>
      <p class="gl-charity" *ngIf="p.charityNote">{{ p.charityNote }}</p>
    </div>
  </section>

  <!-- PlateX, for visitors meeting us for the first time -->
  <section class="gl-platex">
    <div class="gl-wrap gl-narrow">
      <p class="gl-eyebrow gl-eyebrow--dark">About PlateX</p>
      <p class="gl-platex-text">
        PlateX brings the UK private number plate market into one place: compare prices from dealers, the DVLA and
        private sellers, follow auction results and new releases, and see any plate on your car.
      </p>
      <p class="gl-platex-links">
        <a routerLink="/">Search registrations</a>
        <a routerLink="/plates/current-style">New releases</a>
        <a routerLink="/market-guides">More Market Guides</a>
        <a *ngIf="showWoyp" routerLink="/whats-on-your-plate">What's on Your Plate</a>
      </p>
    </div>
  </section>

  <!-- Mobile: the action stays in reach once the hero has scrolled away -->
  <div class="gl-sticky" [class.gl-sticky--on]="stickyCta && lightbox === null" aria-hidden="true">
    <span class="gl-sticky-title">{{ p.title }}</span>
    <button type="button" class="gl-btn gl-btn--small" tabindex="-1" (click)="primaryAction()" [disabled]="claiming || (!entitled && p.phase !== 'complimentary')">
      {{ entitled ? 'Read' : p.phase === 'complimentary' ? 'Claim free copy' : 'Coming soon' }}
    </button>
  </div>

  <!-- Sample page viewer -->
  <div class="gl-lightbox" *ngIf="lightbox !== null" role="dialog" aria-modal="true" [attr.aria-label]="'Sample page ' + previews[lightbox].page"
       (touchstart)="touchStart($event)" (touchend)="touchEnd($event)">
    <div class="gl-lb-bar">
      <span>Sample page {{ previews[lightbox].page }} of {{ p.pageCount }}</span>
      <button type="button" class="gl-lb-close" (click)="closePreview()" aria-label="Close">✕</button>
    </div>
    <div class="gl-lb-stage" (click)="closePreview()">
      <img [src]="previews[lightbox].url" [alt]="'Sample page ' + previews[lightbox].page" (click)="$event.stopPropagation()" />
    </div>
    <div class="gl-lb-nav">
      <button type="button" (click)="stepPreview(-1)" aria-label="Previous sample">‹</button>
      <button type="button" class="gl-btn gl-btn--small" (click)="closePreview(); primaryAction()" *ngIf="entitled || p.phase === 'complimentary'">
        {{ entitled ? 'Read the full guide' : 'Claim the full guide' }}
      </button>
      <button type="button" (click)="stepPreview(1)" aria-label="Next sample">›</button>
    </div>
  </div>
</div>

<!-- The action block, by access state -->
<ng-template #cta let-p>
  <div class="gl-cta">
    <ng-container *ngIf="entitled; else notEntitled">
      <button type="button" class="gl-btn" (click)="openReader()">
        {{ resumePage ? 'Continue reading, page ' + resumePage : 'Read the guide' }}
      </button>
      <p class="gl-cta-note">This guide is in your PlateX account.</p>
    </ng-container>
    <ng-template #notEntitled>
      <ng-container [ngSwitch]="p.phase">
        <ng-container *ngSwitchCase="'complimentary'">
          <button type="button" class="gl-btn" (click)="primaryAction()" [disabled]="claiming">
            {{ claiming ? 'Adding to your account…' : 'Claim your free copy' }}
          </button>
          <p class="gl-cta-note">
            Free with a PlateX account<span *ngIf="freeUntil"> until {{ freeUntil }}</span>. Once claimed, it is yours to keep.
          </p>
          <p class="gl-cta-note">Your free account also unlocks the full 27 release research.</p>
        </ng-container>
        <ng-container *ngSwitchCase="'upcoming'">
          <button type="button" class="gl-btn" disabled>Coming soon</button>
          <p class="gl-cta-note" *ngIf="opensOn">Free to claim from {{ opensOn }}.</p>
        </ng-container>
        <ng-container *ngSwitchDefault>
          <p class="gl-cta-note gl-cta-note--strong">The complimentary edition has closed.</p>
          <p class="gl-cta-note">The guide will be available to buy soon<span *ngIf="price">, priced {{ price }}</span>.</p>
        </ng-container>
      </ng-container>
    </ng-template>
    <p class="gl-cta-error" *ngIf="claimError" role="alert">{{ claimError }}</p>
  </div>
</ng-template>

<ng-template #notReady>
  <div class="gl-status">
    <ng-container [ngSwitch]="state">
      <p *ngSwitchCase="'loading'" class="gl-status-text" aria-live="polite">Loading the guide…</p>
      <ng-container *ngSwitchCase="'missing'">
        <h1 class="gl-status-title">Guide not found</h1>
        <p class="gl-status-text">This guide is not available. <a routerLink="/market-guides">See all Market Guides</a>.</p>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <h1 class="gl-status-title">The guide could not be loaded</h1>
        <p class="gl-status-text">Please refresh the page or try again shortly.</p>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
